import { useApi } from '@/api';
import {
  ActivityCard,
  EntityName,
  KpiCard,
  Page,
  PageSkeleton
} from '@/components';
import { tokensMappingArbitrum } from '@/utils/tokens';
import { CryptoIcon, Flex, Heading } from '@blockanalitica/ui';
import BridgeHistoricGraph from './BridgeHistoricGraph';

export default function ArbitrumBridgePage() {
  const [data, error] = useApi({
    url: '/arbitrum/'
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={<CryptoIcon name={'weth'} size="3" />}
            symbol2={<CryptoIcon name={'arbitrum'} size="3" />}>
            <Heading size="1">
              <Flex gap="xs">SkyLink</Flex>
            </Heading>
          </EntityName>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Assets Bridged"
            data={data}
            field="total_bridge_balance"
            options={{ currency: 'USD' }}
          />
        </Flex>
        <BridgeHistoricGraph />
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Bridged USDS"
            data={data}
            field="usds_bridge_balance"
            variant="usds"
            options={{
              currency: tokensMappingArbitrum('USDS')
            }}
          />

          <KpiCard
            title="Bridged sUSDS"
            data={data}
            field="susds_bridge_balance"
            variant="susds"
            options={{
              currency: tokensMappingArbitrum('sUSDS')
            }}
          />
        </Flex>
        <ActivityCard url={`/arbitrum/bridge/activity/`} linkTo="activity" />
      </Page>
    );
  }
  return <PageSkeleton />;
}
